<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="main-card" flat>
            <v-tabs v-model="tabs" background-color="transparent" centered grow show-arrows slider-color="transparent"
                class="custom-tabs">
                <v-tab :class="['custom-tab', 'first-tab', { 'active-tab': tabs === 0 }]" v-if="profile_relative_tab.indexOf('Under_Id_card_tab_student_Id_card') !== -1">
                    <v-icon class="mr-2">mdi mdi-card-account-details-star</v-icon>Student ID Card
                </v-tab>
                <v-tab :class="['custom-tab', { 'active-tab': tabs === 1 }]" v-if="profile_relative_tab.indexOf('Under_Id_card_tab_student_health_card') !== -1">
                    <v-icon class="mr-2">mdi mdi-heart-pulse</v-icon>Student Health Card
                </v-tab>
                <v-tab :class="['custom-tab', { 'active-tab': tabs === 2 }]" v-if="profile_relative_tab.indexOf('Under_Id_card_tab_parent_escort_card') !== -1">
                    <v-icon class="mr-2">mdi mdi-badge-account</v-icon>Parent Escort Card
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabs">
                <v-tab-item v-if="profile_relative_tab.indexOf('Under_Id_card_tab_student_Id_card') !== -1">
                    <v-card flat>
                        <br>
                        <v-row justify="center">
                        <wws-student-icard v-if="prn != null && tenant == 'wws'" :key="prn" :side-by-side="true" />
                        <vvp-student-icard v-if="prn != null && tenant == 'vvp'" :side-by-side="true" :key="prn" />
                        <sbpps-student-icard v-if="prn != null && tenant == 'sbpps'" :side-by-side="true" :key="prn" />
                        <zeal-student-icard v-if="prn != null && tenant == 'zeal'" :key="prn" :side-by-side="true" />
                        <sanjivani-student-icard v-if="prn != null && tenant == 'sanjivani'" :key="prn" :side-by-side="true" />
                        <uws-student-icard v-if="prn != null && tenant == 'uwws'" :key="prn" :side-by-side="true" />
                        <tmv-student-icard v-if="prn != null && tenant == 'tmvidyalaya'" :key="prn" />
                        </v-row>
                        <br>
                    </v-card>
                </v-tab-item>
                <v-tab-item v-if="profile_relative_tab.indexOf('Under_Id_card_tab_student_health_card') !== -1">
                    <v-card flat v-if="tenant == 'sbpps'">
                        <student-health-card v-if="child_div_id != null" :child_div_id="child_div_id"
                        :key="child_div_id" />
                    </v-card>
                    <v-card flat v-else>
                        <div class="center-screen">
                            <v-img class="img-size" :src="imageSrc" alt="Under Development" contain></v-img>
                        </div>
                    </v-card>
                </v-tab-item>
                <v-tab-item v-if="profile_relative_tab.indexOf('Under_Id_card_tab_parent_escort_card') !== -1">
                        <br>
                        <v-row justify="center">
                        <template v-if="prn != null">
                            <v-card flat v-if="tenant == 'wws'">
                            <wws-parent-icard :key="prn" :stud_data="learner_id" :side-by-side="true" />
                            </v-card>

                            <v-card flat v-else-if="tenant == 'uwws'">
                            <uws-parent-icard :key="prn" :side-by-side="true" />
                            </v-card>

                            <v-card flat v-else-if="tenant == 'sbpps'">
                            <sbpps-parent-icard :key="prn" :side-by-side="true" />
                            </v-card>

                            <v-card flat v-else>
                            <div class="center-screen">
                                <v-img class="img-size" :src="imageSrc" alt="Under Development" contain></v-img>
                            </div>
                            </v-card>
                        </template>
                        </v-row>
                        <br>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import UnderDevelopement from "@/components/shared/UnderDevelopement.vue";
import StudentHealthCard from "../../HealthCard/StudentHealthCard.vue";
import WwsStudentIcard from "../../Icard/WwsStudentSpecificIcardPrint.vue";
import VvpStudentIcard from "../../Icard/VVPStudentSpecificIcardPrint.vue";
import SbppsStudentIcard from "../../Icard/SbppsStudentSpecificIcardPrint.vue";
import ZealStudentIcard from "../../Icard/ZealStudentSpecificICardPrint.vue";
import SanjivaniStudentIcard from "../../Icard/SanjivaniStudentSpecificIcardPrint.vue";
import UwsStudentIcard from "../../Icard/UwwsStudentSpecificIcardPrint.vue";
import TmvStudentIcard from "../../Icard/TMVStudentSpecificIcardPrint.vue";
import UwsParentIcard from "../../Icard/UwwsParentSpecificIcardPrint.vue";
import SbppsParentIcard from "../../Icard/SbppsParentSpecificIcardPrint.vue";
import WwsParentIcard from "../../Icard/WwsStudentEscortPrint.vue";
export default {
    props: {
        learner: {
            type: [String, Number], 
            required: true
        },
         profile_relative_tab: {
    type: Array,
    default: () => []
  }
    },
    components: { 
        UnderDevelopement,
        "student-health-card" : StudentHealthCard,
        "wws-student-icard" : WwsStudentIcard,
        "vvp-student-icard" : VvpStudentIcard,
        "sbpps-student-icard" : SbppsStudentIcard,
        "zeal-student-icard" : ZealStudentIcard,
        "sanjivani-student-icard" : SanjivaniStudentIcard,
        "uws-student-icard" : UwsStudentIcard,
        "tmv-student-icard" : TmvStudentIcard,
        "uws-parent-icard" : UwsParentIcard,
        "sbpps-parent-icard" : SbppsParentIcard,
        "wws-parent-icard" : WwsParentIcard,
     },
    data() {
        return {  
            color: "",
            snackbar: false,
            snackbar_msg: "",
            child_div_id: '',
            learner_id:'',
            prn:'',
            search: '',
            tenant: null,
            tabs: 0,
            imageSrc: require('@/assets/no_data_found.jpg')
        };

    },
    watch: {
        learner(newVal, oldVal) {
            if (newVal) {
                this.getIcardDetails();
            }
        }
    },

    methods: {
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getIcardDetails() {

            const data = {
                learner: this.learner
            }
            axios
                .post("/parent/getIcardDetails", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                       this.child_div_id = res.data.ldid;
                       this.learner_id = res.data.learner_id;
                       this.prn = res.data.prn;
                       localStorage.setItem("child_div_id", JSON.stringify(this.child_div_id));
                       localStorage.setItem("prn", JSON.stringify(this.prn));                      
                    } else {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                    this.fetch_loader = false;
                })

        },
    },
    mounted() {
        this.tenant = localStorage.getItem("EPS-tenant")
        this.getIcardDetails();
    },
};
</script>

<style scoped>
.img-size {
  width: 555px;
  height: 345px;
}
.center-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.custom-toolbar {
    background: linear-gradient(to right, #a8edea, #e4d0ff);
    background: linear-gradient(to right, #a8edea, #e4d0ff);
}

.sibling-table td,
tr,
th {
    border-collapse: collapse;
}

.button-77 {

    color: #fff;
    cursor: pointer;
    font-weight: 800;
    vertical-align: middle;
    z-index: 0;
}
.button-77:before,
.button-77:after {
    border-radius: 80px;
}

.button-77:before {
    background-color: rgba(249, 58, 19, .32);
    content: "";
}

.button-77:after {
    background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    content: "";
    display: block;
    left: 4px;
    overflow: hidden;
    position: absolute;
    right: 4px;
    top: 4px;
    transition: all 100ms ease-out;
    z-index: -1;
}

.button-77:hover:not(:disabled):after {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transition-timing-function: ease-in;
}

.button-77:active:not(:disabled) {
    color: #ccc;
}

.button-77:active:not(:disabled):after {
    background-image: linear-gradient(0deg, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2)), linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    left: 4px;
    right: 4px;
    top: 4px;
}

.button-77:disabled {
    cursor: default;
    opacity: .24;
}

.custom-toolbar {
    background: linear-gradient(to right, #a8edea, #e4d0ff);
    background: linear-gradient(to right, #a8edea, #e4d0ff);
}

.main-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.custom-tabs {
    background: linear-gradient(to right, #b2d8f7, #f4d1f4);
    border-radius: 30px;
    padding: 2px;
    min-height: 50px;
}

.custom-tab {
    font-weight: normal;
    color: black;
    text-transform: uppercase;
    font-size: 14px;
    min-height: 40px;
    border-radius: 0;
}

.first-tab {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
}

.last-tab {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
}

.active-tab {
    background: white !important;
    color: black !important;
    font-weight: bold !important;
}

.under-development {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #f5f6fa;
    text-align: center;
}

.content {
    padding: 20px;
    border: 2px dashed #ccc;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

h1 {
    color: #333;
    margin-top: 20px;
    font-size: 24px;
}

p {
    color: #666;
    font-size: 16px;
}

.custom-header {
  background-color: #E0E0E0 !important;
  color: black !important; /* Optional: makes text readable */
  font-weight: bold;
}
</style>